import React, { useState, useContext, useEffect } from "react";
import { Modal, Carousel } from "react-bootstrap";
import { VehiculosContext } from "../../context/VehiculosContext";

import iconoCerrar from "../../assets/img/icono-cerrar.svg";
import Formulario from "../Formulario/Formulario";
import { MainContent } from "../MainContent/MainContent";

export const Header = () => {
  const [showWarning, setShowWarning] = useState(false);
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => setShow(true);
  const handleShowWarning = () => setShowWarning(true);

  const handleCloseAll = () => {
    setShowWarning(false);
    handleClose();
  };

  const handleCloseWarning = () => setShowWarning(false);

  const { vehiculos, setVehiculos, arrayVehiculos, marcaLanding, modeloLanding } = useContext(VehiculosContext);

  useEffect(() => {
    if (vehiculos.name === "IMPETUS CVT") {
      document.body.style.background = " linear-gradient(180deg, #A31445 -24.53%, #FF1430 109.17%);";
    }

    if (vehiculos.name === "DRIVE MT5") {
      document.body.style.background = "linear-gradient(180deg, #FF1430 -27.08%, #A31445 109.17%);";
    }

    if (vehiculos.name === "DRIVE CVT") {
      document.body.style.background = "linear-gradient(180deg, #A31445 -43.89%, #FF1430 135.6%);";
    }

    // seteo el carrusel al primer elemento
    setIndexVehicle(0);
  }, [vehiculos]);

  // guardo en sessionStorage los utm_source y utm_medium
  const url = window.location.search;
  const searchParams = new URLSearchParams(url);
  const utmSource = searchParams.get("utm_source");
  const utmMedium = searchParams.get("utm_medium");
  useEffect(() => {
    if (utmSource) {
      sessionStorage.setItem("utm_source", utmSource);
    }
    if (utmMedium) {
      sessionStorage.setItem("utm_medium", utmMedium);
    }
  }, [utmSource, utmMedium]);
  // fin guardo en sessionStorage los utm_source y utm_medium

  // solucion index cero cuando cambiamos de modelo
  const [indexVehicle, setIndexVehicle] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndexVehicle(selectedIndex);
  };

  return (
    <div>
      <h1 className="titulo-principal">
        {marcaLanding} {modeloLanding} <span>MY 24</span>
      </h1>

      {arrayVehiculos
        .filter((v) => v.name === vehiculos)
        .map((vehicle, index) => (
          <>
            <Carousel
              className="mt-5 mb-5 vehiclesSlider"
              controls={true}
              activeIndex={indexVehicle}
              onSelect={handleSelect}
            >
              {vehicle.img.map((v, index) => (
                <Carousel.Item>
                  {<img className="d-block w-100 img-fluid items-sliders-principal" src={v} alt={vehicle.name} />}
                </Carousel.Item>
              ))}
            </Carousel>
          </>
        ))}

      <section className="contenedorBotonesVersiones pb-4 pt-2">
        {arrayVehiculos.map((vehicle, index) => (
          <button
            key={index}
            onClick={() => setVehiculos(vehicle.name)}
            className={vehiculos === vehicle.name ? "butonActive" : ""}
          >
            {vehicle.name}
          </button>
        ))}
      </section>

      <MainContent handleShowProp={handleShow} />

      <Modal show={show} onHide={handleClose} centered id="modal-contacto-header">
        <Modal.Header>
          <h5 className="titulo-modal-contacto"> Hacé tu consulta </h5>
          <button className="boton-cerrar-modal" onClick={handleClose}>
            <img src={iconoCerrar} alt="Icono Cerrar" />
          </button>
        </Modal.Header>
        <Modal.Body>
          <Formulario
            vMarca={marcaLanding}
            vModelo={vehiculos}
            filtrados={arrayVehiculos}
            tipo="convencional"
            handleShow={handleShow}
            handleClose={handleClose}
            handleCloseAll={handleCloseAll}
            handleShowWarning={handleShowWarning}
            showWarning={showWarning}
            handleCloseWarning={handleCloseWarning}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};
